import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

var cs = {
  language: 'cs',
  country: 'cz',
  name: 'Čeština',
  embeddedLocale: merge(error, login),
  flags: ['CZ'],
};

export { cs as default };
